<template>
    <div>
        <FlyerlineModal :name="modalName" ref="modalRef">
            <div>
                <AddressBookTable :addresses="addresses" @select="handleSelection" @edit="handleEdit"/>
                <button class="btn w-100@until-medium float-right" @click="handleNew">{{'versandaufteilungAddressbuchAdd'|translate}}</button>
                <div class="clearfix"></div>
            </div>
        </FlyerlineModal>

        <!-- Modals -->
        <AddressBookAddAddress ref="addAddressModal"/>
        <AddressBookUpdateAddress ref="updateAddressModal" />

    </div>
</template>

<script>
    import {doGet} from "classes/api.js";
    import {translatePrj} from "classes/vue-dict-filter";
    import {capitalizeFirstLetter} from "classes/helpers";
    import FlyerlineModal from "fragments/FlyerlineModal";
    import SkyFormLoader from "fragments/SkyFormLoader";
    import AddressBookTable from "./AddressBookTable";
    import ComponentPromise from "mixins/ComponentPromise";
    import AddressBookAddAddress from './AddressBookAddAddress';
    import AddressBookUpdateAddress from './AddressBookUpdateAddress'


    const prefix = 'versandaufteilung';

    function getTitle(name) {
        return translatePrj(prefix + capitalizeFirstLetter(name)) || "";
    }

    export default {
        name: "AddressBook",
        components: {AddressBookUpdateAddress, AddressBookAddAddress, AddressBookTable, FlyerlineModal, SkyFormLoader},
        mixins: [ComponentPromise],
        created() {
            this.modalName = 'addressBookModal'
        },
        mounted() {
        },
        data() {
            return {addresses: [], addresskey: ""}
        },
        watch: {},
        methods: {
            open(data) {
                this.loadAddresses()
                this.$refs.modalRef.open()

                return this.createPromise()
            },
            handleSelection(data) {
                //TODO: s
                this.resolver({
                    deliveryaddress: data,
                    addressinfoid: data.key
                })
                this.$refs.modalRef.close()
            },
            handleEdit(data) {
                this.$refs.updateAddressModal.open(data.key)
                .then( data => this.loadAddresses())
            },

            handleNew(){
                this.$refs.addAddressModal.open()
                .then( data => this.loadAddresses() )
            },

            loadAddresses() {
                return doGet("/api/prj/customer/addresses.json")
                    .then(res => {
                        this.addresses = res.addresses
                        this.addresskey = this.addresses[0].key
                    })
            },
        }

    }
</script>

<style scoped>

</style>